import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScheduleEvent } from '../../containers/Schedule/Schedule';
import moment from 'moment';

interface CustomEventProps {
    event: ScheduleEvent;
}

const MAX_PRIORITY = 3;

const PRIORITY_LEVELS: Record<number, string> = {
    0: 'low',
    1: 'medium',
    2: 'high',
};

const CustomEvent: React.FC<CustomEventProps> = ({ event }) => {

    const [t] = useTranslation();

    const timeLabel = (() => {
        if (event.is_time_slot && event.start_time && event.end_time) {
            return `${event.start_time.slice(0, 5)} – ${event.end_time.slice(0, 5)}`;
        }
        if (event.start) {
            const s = moment(event.start).format('HH:mm');
            const e = event.end ? moment(event.end).format('HH:mm') : null;
            return e ? `${s} – ${e}` : s;
        }
        return null;
    })();

    const priority = Math.min(Math.max(Number(event.priority), 0), 2);
    const level = PRIORITY_LEVELS[priority] ?? 'low';

    return (
        <div className="event">
            <div className="event-title">{event.title}</div>

            {timeLabel && (
                <div className="event-time">{timeLabel}</div>
            )}

            <div className="mt-3">
                <div className="event-title">{t('Priority')}:</div>
                <div className={`event-priority event-priority--${level} mt-1`}>
                    <div className="event-priority-bar">
                        {Array.from({ length: MAX_PRIORITY }, (_, i) => (
                            <span
                                key={i}
                                className={`event-priority-segment${i <= priority ? ' event-priority-segment--filled' : ''}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );

};

export default React.memo(CustomEvent);
